export default __webpack_public_path__ + "static/media/Roboto-Bold.d9545f10.woff";